import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { DocumentLinkDirective } from './directives/document.directive';
import { MustMatchValidatorDirective, ValidateOnClickDirective } from './directives/form.directive';
import { ImagePreloadDirective } from './directives/image-preload.directive';
import { RouterHomeLinkDirective } from './directives/router.directive';

import {
	AuthenticatedOnlyDirective,
	DisplayForClaimsDirective,
	HideForClaimsDirective,
	NotSwitchedFromAdminOnlyDirective,
	SwitchedFromAdminOnlyDirective,
	UnauthenticatedOnlyDirective,
} from './directives/user.directive';

import { TranslateModule } from '@ngx-translate/core';

import { GoogleMapsModule } from '@angular/google-maps';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

import { AgePipe } from './pipes/age.pipe';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { SortGridPipe } from './pipes/datesort.pipe';
import { JsonStringPipe } from './pipes/json-string.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { SplitPipeStringPipe } from './pipes/split-pipe-string.pipe';
import { SumPipe } from './pipes/sum.pipe';
import { TextSearchPipe } from './pipes/text-search.pipe';

import { AddHostMemberComponent } from './components/add-host-member/add-host-member.component';
import { AddMembershipListingComponent } from './components/add-membership-listing/add-membership-listing.component';
import { DobPickerComponent } from './components/dob-picker/dob-picker.component';
import { LanguagesComponent } from './components/languages/languages.component';
import { OnBoardingComponent } from './components/onboarding/onboarding.component';
import { ProductServicePricingPlanComponent } from './components/product-service-pricing-plan/product-service-pricing-plan.component';
import { ProtectionPlanPricingPlanComponent } from './components/protection-plan-pricing-plan/protection-plan-pricing-plan.component';
import { PromoCodeLookupComponent } from './components/promocode-lookup/promocode-lookup.component';
import { TelephonePickerComponent } from './components/telephone-picker/telephone-picker.component';

import { BookingListComponent } from './components/bookings/booking-list/booking-list.component';
import { BookingMetricsComponent } from './components/bookings/booking-metrics/booking-metrics.component';
import { BookingSearchComponent } from './components/bookings/booking-search/booking-search.component';
import { BookingStatusComponent } from './components/bookings/booking-status/booking-status.component';
import { CurrencySelectComponent } from './components/currency-select/currency-select.component';
import { TimelineIncidentComponent } from './components/timeline-incident/timeline-incident.component';

import { DatePickerComponent } from './components/date-picker/date-picker.component';

import { CopyToClipboardButtonComponent } from './components/copy-to-clipboard-button/copy-to-clipboard-button.component';
import { LogoUploaderComponent } from './components/logo-uploader/logo-uploader.component';
import { PlatformModule } from '@angular/cdk/platform';
import { CancelVerificationModal } from '../dashboards/platform/cancel-verification-modal/cancel-verification-modal.component';
import { MatDialogModule } from '@angular/material/dialog';

const components = [
	AddHostMemberComponent,
	AddMembershipListingComponent,
	AgePipe,
	AuthenticatedOnlyDirective,
	BookingListComponent,
	BookingMetricsComponent,
	BookingSearchComponent,
	BookingStatusComponent,
	CopyToClipboardButtonComponent,
	CurrencySelectComponent,
	DateAgoPipe,
	DatePickerComponent,
	DisplayForClaimsDirective,
	DobPickerComponent,
	DocumentLinkDirective,
	HideForClaimsDirective,
	ImagePreloadDirective,
	JsonStringPipe,
	LanguagesComponent,
	LogoUploaderComponent,
	MustMatchValidatorDirective,
	NotSwitchedFromAdminOnlyDirective,
	OnBoardingComponent,
	ProductServicePricingPlanComponent,
	ProtectionPlanPricingPlanComponent,
	PromoCodeLookupComponent,
	RouterHomeLinkDirective,
	SafePipe,
	SortGridPipe,
	SplitPipeStringPipe,
	SumPipe,
	SwitchedFromAdminOnlyDirective,
	TelephonePickerComponent,
	TextSearchPipe,
	TimelineIncidentComponent,
	UnauthenticatedOnlyDirective,
	ValidateOnClickDirective,
	CancelVerificationModal,
];

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		MatPaginatorModule,
		MatSortModule,
		MatStepperModule,
		MatTableModule,
		MatFormFieldModule,
		MatAutocompleteModule,
		MatExpansionModule,
		MatIconModule,
		MatInputModule,
		MatTooltipModule,
		RouterModule,
		FormsModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatMenuModule,
		GoogleMapsModule,
		MatSlideToggleModule,
		PlatformModule,
		MatDialogModule
	],
	declarations: components,
	exports: [
		CommonModule,
		FormsModule,
		GoogleMapsModule,
		MatAutocompleteModule,
		MatExpansionModule,
		MatIconModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatInputModule,
		MatMenuModule,
		MatNativeDateModule,
		MatPaginatorModule,
		MatSortModule,
		MatStepperModule,
		MatTableModule,
		MatTooltipModule,
		MatSlideToggleModule,
		RouterModule,
		TranslateModule,
		MatDialogModule,
		...components,
	],
	providers: [TextSearchPipe, SafePipe, AgePipe, JsonStringPipe, DatePipe],
})
export class SharedModule {}
